import { render, staticRenderFns } from "./TableNumber2.vue?vue&type=template&id=286c9ebd&"
import script from "./TableNumber2.vue?vue&type=script&lang=js&"
export * from "./TableNumber2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports